import HOContactDetailsView from 'text!../views/ho-contact-details.html';
import HOPreQualQuestionsView from 'text!edge/quoteandbind/common/views/prequal-questions.html';
import HOYourHomeView from 'text!../views/ho-your-home.html';
import HOConstructionView from 'text!../views/ho-construction.html';
import HORatingView from 'text!../views/ho-rating.html';
import HOPolicyInfoView from 'text!../views/ho-policy-info.html';
import HOContactDetailsCtrl from '../controllers/HOContactDetailsCtrl';
import HOPreQualQuestionsCtrl from '../controllers/HOPrequalQuestionsCtrl';
import HOYourHomeCtrl from '../controllers/HOYourHomeCtrl';
import HOConstructionCtrl from '../controllers/HOConstructionCtrl';
import HORatingCtrl from '../controllers/HORatingCtrl';
import HOPolicyInfoCtrl from '../controllers/HOPolicyInfoCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        hoContactDetails: {
            parent: wizardParentState,
            template: HOContactDetailsView,
            controller: HOContactDetailsCtrl
        },
        hoPrequalQuestions: {
            parent: wizardParentState,
            template: HOPreQualQuestionsView,
            controller: HOPreQualQuestionsCtrl
        },
        hoYourHome: {
            parent: wizardParentState,
            template: HOYourHomeView,
            controller: HOYourHomeCtrl
        },
        hoConstruction: {
            parent: wizardParentState,
            template: HOConstructionView,
            controller: HOConstructionCtrl
        },
        hoRating: {
            parent: wizardParentState,
            template: HORatingView,
            controller: HORatingCtrl
        },
        hoPolicyInfo: {
            parent: wizardParentState,
            template: HOPolicyInfoView,
            controller: HOPolicyInfoCtrl
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/config/RouteConfig.js
// module id = 2146
// module chunks = 0